import { render } from "./media-blocks.vue?vue&type=template&id=1614264a"
import script from "./media-blocks.vue?vue&type=script&lang=js"
export * from "./media-blocks.vue?vue&type=script&lang=js"

import "./media-blocks.vue?vue&type=style&index=0&id=1614264a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__